import React from 'react';
import shortid from 'shortid';
import PropTypes from 'prop-types';

import PlanDetail from './PlanDetail';

const PlanContainer = ({ data, closePanel, buyCallback }) => {
  return (
    <>
      {data.map(item => {
        return (
          <PlanDetail
            closePanel={closePanel}
            key={shortid.generate()}
            data={item}
            buyCallback={buyCallback}
          />
        );
      })}
    </>
  );
};

PlanContainer.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.number,
    })
  ).isRequired,
  closePanel: PropTypes.func.isRequired,
  buyCallback: PropTypes.func.isRequired,
};

export default PlanContainer;
